import { Heart, Github, BookOpen, Shield } from 'lucide-react'

export function Footer() {
  return (
    <footer className="py-12 px-6 border-t border-border">
      <div className="max-w-5xl mx-auto text-center">
        <p className="text-muted-foreground text-sm mb-4">
          Made with <Heart className="w-4 h-4 inline text-secondary mx-1" /> using open-source technologies
        </p>
        <div className="flex justify-center gap-6 flex-wrap">
          <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors text-sm flex items-center gap-1.5">
            <Github className="w-4 h-4" /> GitHub
          </a>
          <a href="#" className="text-muted-foreground hover:text-primary transition-colors text-sm flex items-center gap-1.5">
            <BookOpen className="w-4 h-4" /> Documentation
          </a>
          <a href="#" className="text-muted-foreground hover:text-primary transition-colors text-sm flex items-center gap-1.5">
            <Shield className="w-4 h-4" /> Privacy
          </a>
        </div>
        <div className="mt-6 text-xs text-muted-foreground/50 space-y-1">
          <p>Images: Pollinations.AI | TTS: Web Speech API | Scripts: AI Templates</p>
          <p>Video generation requires third-party API keys (Replicate, fal.ai, etc.)</p>
        </div>
      </div>
    </footer>
  )
}
